import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    BrandItems: [],
};

const brandSlice = createSlice({
    name: 'Brand',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getBrandSuccess(state, action) {
            state.isLoading = false;
            state.BrandItems = action.payload;
        },
    },
});

export default brandSlice.reducer;

export const { startLoading, hasError, getBrandSuccess } = brandSlice.actions;

export const getAllBrands = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/brand/get-all-brand');
        dispatch(getBrandSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addBrand = (Brand) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const response = await axios.post('attributes/brand/brand-add', {
            Brand,
            AddedBy: `${currentUser?.firstName} ${currentUser?.lastName}`,
        })
        dispatch(getAllBrands());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteBrand = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/brand/brand-delete/${id}`);
        dispatch(getAllBrands());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateBrand = (Brand, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/brand/brand-update/${id}`, {
            Brand,
        });
        dispatch(getAllBrands());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};